export const convertFormula = (input, options) => {
    if (!input)
        return null
    const usedIds = new Set();

    const convertedFormula = input?.replace(/#([a-zA-Z0-9_]+)/g, (_, label) => {
        const found = options.find(opt => opt.label === label);
        if (found) {
            usedIds.add(found.value);
            return found.value;
        }
        return label; // fallback to label if not found
    });

    return {
        convertedFormula,
        dependencies: Array.from(usedIds),
    };
};


export const revertFormula = (input, options) => {
    if (!input) return undefined;

    const usedIds = new Set();

    // Replace each ID with its corresponding #label
    const convertedFormula = input.replace(/[a-f0-9]{24}/g, (id) => {
        const found = options.find(opt => opt.value === id);
        if (found) {
            usedIds.add(id);
            return `#${found.label}`;
        }
        return id;
    });

    return convertedFormula

};